import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { OrdenProvider } from '../../providers/orden/orden';
import { Order } from '../../models/order';
import { AuthProvider } from '../../providers/auth/auth';
import {Subscription} from "rxjs/Subscription";
import { DetalleOrdenPage } from '../detalle-orden/detalle-orden';
import { CrearOrdenPage } from '../crear-orden/crear-orden';
import {CallNumber} from '@ionic-native/call-number';
import { EditOrdenPage } from '../edit-orden/edit-orden';

/**
 * Generated class for the OrdensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ordens',
  templateUrl: 'ordens.html',
})
export class OrdensPage {
  id: any;
  orders: Order;
  getCredentialsSubscription: Subscription;
  name: any;
  data={ estatus: 'venta'}
    
   
  

 
  constructor(public navCtrl: NavController, public navParams: NavParams, private orderProvider: OrdenProvider,private authProvider: AuthProvider,  private loadingCtrl: LoadingController, private alertCtrl: AlertController, private call: CallNumber,) {
  }

  ngOnInit() {
    this.getCredentialsSubscription = this.authProvider.getCrendentials.subscribe((res) => {
      if (res.accessToken) {
      this.id=  res.user_id;
      this.name= res.name;
      }
    })
   

    this.orderProvider.getOrders(this.id)
      .subscribe(
        (res: Order) => {
          this.orders = res;
          console.log(res);
        },
        (err) => {
          console.log(`Error en obtener la orden`, err);
        })
    
    // this.navParams.get('id');

    // this.orderProvider.getOrders(id)
    //   .subscribe(
    //     (res: Order) => {
    //       this.orden = res;
    //     },
    //     (err) => {
    //       console.log(`Error en obtener la orden`, err);
    //     })
    // console.log('ionViewDidLoad OrdensPage');

  }

  openOrdenDetail(id) {

    this.navCtrl.push(DetalleOrdenPage, {id});

  }

  goHome(name){
    this.navCtrl.push(CrearOrdenPage, {name});
    }

    
  openEditOrden(id){
    this.navCtrl.push(EditOrdenPage, {id});
    }

  changeState(id){
    
   this.alertCtrl.create({
      subTitle: '¿Deseas dar como completada esta cotización?',
          buttons: [
            'Cancelar',
            {
              text: 'Okey',
              handler: () => {
                let loading = this.loadingCtrl.create({
                  content: 'Terminando Orden...'
                });
            
                loading.present();
                console.log(id);
                this.orderProvider.changeState(id, this.data)
                  .subscribe((res) => {
                      loading.dismiss(); 
                      if (res) { 
                        this.navCtrl.push(OrdensPage)
                      }
                    },
                    (err) => {
                      loading.dismiss();
                      console.log("ERROR: ", err);
                    })
              }
            }
          ]
        }).present();
  }

diallerCall(number){
  console.log(number);
  this.call.callNumber(number, true)
  .then(res => console.log('Launched dialer!', res))
  .catch(err => console.log('Error launching dialer', err));
}


  
}



// WEBPACK FOOTER //
// ./src/pages/ordens/ordens.ts